<template>
  <div class="image-text">
    <slot class="image" name="image"></slot>
    <slot class="text" name="text"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextRightMiddle",
};
</script>

<style lang="scss" scoped>
.image-text {
  align-items: center;

  @include mobile {
    flex-direction: column;
  }

  .text {
    flex: 1;
  }

  .image {
    flex: 3;
  }
}
</style>
